import { MockEventCollector } from "./EventCollector";
import { EventCollectorLoader } from "./EventCollectorLoader";
import { reportAppError, reportAppEvent } from "./utils/CoreReport";
import { startAdBlockerDetection } from "./utils/BlockerDetect";

// Arranca ya (en paralelo con toda la init): así el resultado está cacheado
// cuando el onPageView construya su custom_data.
startAdBlockerDetection();

const mockEventCollector =
  window.EventCollector as unknown as MockEventCollector;

if (!mockEventCollector) {
  console.error("Mock EventCollector is not defined on window");
}

const loader = new EventCollectorLoader(mockEventCollector);

// Telemetría del issue 1F (el bundle no cargaba a la primera): si este código
// está corriendo desde la URL de reintento (?r=1, la añade el onerror del
// loader SSR) o desde el fallback absoluto cross-site, dejar constancia — es
// la medición de cuántas sesiones rescata cada escalón de la cadena de carga.
try {
  const bootSrc = (document.currentScript as HTMLScriptElement | null)?.src || "";
  if (bootSrc.includes("r=1")) {
    reportAppEvent("loader_recovered", { app_via: "retry" });
  } else if (
    bootSrc.startsWith("http") &&
    !bootSrc.includes(window.location.host)
  ) {
    reportAppEvent("loader_recovered", { app_via: "fallback" });
  }
} catch (e) {
  // jamás romper el arranque por telemetría
}

// Bootstrap with retry (W2.6): in flaky webviews the whole init can fail at
// page load even after the config-level retries. Until an attempt succeeds the
// preload mock keeps queueing calls (EventCollector.do from the optin form,
// etc.), and they all resolve the moment a later attempt gets through — so a
// lead submitted while the collector was still down is sent, not lost. Delays
// are long on purpose: the network flaps we measured last seconds, not ms.
const INIT_RETRY_DELAYS_MS = [0, 3000, 15000, 60000];

(async () => {
  for (let attempt = 0; attempt < INIT_RETRY_DELAYS_MS.length; attempt++) {
    if (INIT_RETRY_DELAYS_MS[attempt] > 0) {
      await new Promise((resolve) =>
        setTimeout(resolve, INIT_RETRY_DELAYS_MS[attempt]),
      );
    }
    try {
      const eventCollector = await loader.init();
      window.EventCollector = eventCollector;
      console.log(
        "EventCollector initialized and assigned to window.EventCollector",
      );
      if (attempt > 0) {
        // señal fiable: el init entró en un reintento con la red ya recuperada
        reportAppEvent("app_init_recovered", {
          app_phase: "init",
          app_attempt: attempt + 1,
        });
      }
      return;
    } catch (error) {
      console.warn(
        `EventCollector init attempt ${attempt + 1}/${INIT_RETRY_DELAYS_MS.length} failed`,
        error,
      );
      reportAppError(error, { app_phase: "init", app_attempt: attempt + 1 });
    }
  }
  // Collector down for the whole session.
  reportAppError(new Error("app_init_exhausted"), {
    app_phase: "init",
    app_attempt: INIT_RETRY_DELAYS_MS.length,
  });
})();
